/**
 * Created by john on 8/31/15.
 */

'use strict';

import User from '../models/User';
import storage from 'dibs-browser-storage';
import UserStore from '../../global/stores/UserStore.es';
import qs from 'qs';
import { MEASUREMENT_UNIT_CHANGED } from '../constants/measurementUnitActionConstants.es';
import {
    MEASUREMENT_UNIT_PARAM,
    UNIT_CENTIMETERS,
    UNIT_INCHES,
} from '../../finding/components/Dimensions/constants.es';

const MEASUREMENT_UNIT_PREFERENCE = 'userMeasurementUnit';
const allowedMeasurementUnit = [UNIT_CENTIMETERS, UNIT_INCHES];
const localStorageHelper = storage.localStorage;
const sessionStorageHelper = storage.sessionStorage;

const measurementActions = {
    _updateSessionStorage: (actionContext, payload, done) => {
        const { measurementUnit } = payload;
        sessionStorageHelper.setItem(MEASUREMENT_UNIT_PREFERENCE, measurementUnit);
        done();
    },

    updateLocalStorage: (actionContext, payload, done) => {
        const { measurementUnit } = payload;
        localStorageHelper.setItem(MEASUREMENT_UNIT_PREFERENCE, measurementUnit);
        done();
    },

    updateMeasurementUnit: (actionContext, payload, done) => {
        let { measurementUnit } = payload;

        if (allowedMeasurementUnit.indexOf(measurementUnit) === -1) {
            measurementUnit = UNIT_INCHES;
        }

        if (measurementUnit) {
            actionContext.dispatch(MEASUREMENT_UNIT_CHANGED, { measurementUnit });
        }
        done();
    },
    /**
     * Loads the preferred measurement unit for logged out user,
     * give no measurement-unit query param in ur.
     * From local storage, if not then
     * from session storage, if not then
     * default to inches
     * @param actionContext
     */
    _loadPreferredMeasurementUnit: (actionContext, payload, done) => {
        const localStoreMeasurementUnit = localStorageHelper.getItem(MEASUREMENT_UNIT_PREFERENCE);
        const sessionStoreMeasurementUnit = sessionStorageHelper.getItem(
            MEASUREMENT_UNIT_PREFERENCE
        );

        if (localStoreMeasurementUnit || sessionStoreMeasurementUnit) {
            const measurementUnit = localStoreMeasurementUnit || sessionStoreMeasurementUnit;
            // Update store to local "measurement unit" if it exists, otherwise use session "measurement unit"
            actionContext
                .executeAction(measurementActions.updateMeasurementUnit, { measurementUnit })
                .catch(() => {})
                .then(() => done());
        } else {
            // If not local or session measurement, default to inches
            actionContext
                .executeAction(measurementActions.updateMeasurementUnit, {
                    measurementUnit: UNIT_INCHES,
                })
                .catch(() => {})
                .then(() => done());
        }
    },

    /**
     * Loads the default measurement unit for the current user.
     * @param actionContext
     * @param payload
     * @param payload.userLoadOptions
     */
    loadMeasurementUnitForUser: (actionContext, payload, done) => {
        const queryParams = qs.parse(window.location.search.substr(1));
        const queryMeasurementUnit = queryParams[MEASUREMENT_UNIT_PARAM]
            ? queryParams[MEASUREMENT_UNIT_PARAM]
            : null;

        if (!!queryMeasurementUnit && allowedMeasurementUnit.indexOf(queryMeasurementUnit) > -1) {
            // If "measurement-unit" query param present, update session storage and user store
            Promise.all([
                actionContext.executeAction(measurementActions._updateSessionStorage, {
                    measurementUnit: queryMeasurementUnit,
                }),
                actionContext.executeAction(measurementActions.updateMeasurementUnit, {
                    measurementUnit: queryMeasurementUnit,
                }),
            ]).then(() => done());
        } else {
            Promise.resolve(User.load(payload.userLoadOptions))
                .then(() => {
                    const userModel = User.getCurrentUser();

                    /*
                     When the user is registering, we do an initial save on successful password entry,
                     and we login the user. User.load gets triggered and we get a default
                     measurement unit (IN) from the BE. So we ignore this call, because otherwise we'll
                     overwrite the users currently set measurement unit.
                     */
                    if (userModel.get('newUser')) {
                        userModel.set('newUser', false);
                        return Promise.resolve();
                    } else {
                        const measurementUnit = User.getMeasurementUnit().toLowerCase();
                        const prevMeasurementUnit = actionContext
                            .getStore(UserStore)
                            .getMeasurementUnit().toLowerCase();
                        const isValidMeasurementUnit =
                            !!measurementUnit &&
                            allowedMeasurementUnit.indexOf(measurementUnit) > -1;

                        // If valid user measurement unit differs from store, update local storage and store
                        if (isValidMeasurementUnit && prevMeasurementUnit !== measurementUnit) {
                            return Promise.all([
                                actionContext.executeAction(measurementActions.updateLocalStorage, {
                                    measurementUnit,
                                }),
                                actionContext.executeAction(
                                    measurementActions.updateMeasurementUnit,
                                    {
                                        measurementUnit,
                                    }
                                ),
                            ]);
                        }
                        return Promise.resolve();
                    }
                })
                .catch(() => {
                    return actionContext.executeAction(
                        measurementActions._loadPreferredMeasurementUnit
                    );
                })
                .then(() => done());
        }
    },
};

export default measurementActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/measurementActions.es.js